import { useEffect, useState } from 'react';
import { isKioskMode } from './urlUtils';

// Responsive mode: desktop if width > height, else mobile (forced to mobile in kiosk mode)
export default function useResponsiveMode() {
  const getSnapshot = () => {
    if (typeof window === 'undefined') {
      return { width: 0, height: 0, mode: 'desktop', isDesktop: true, isMobile: false };
    }
    
    // Force mobile mode in kiosk mode
    if (isKioskMode()) {
      const width = window.outerWidth || 0;
      const height = window.outerHeight || 0;
      return {
        width,
        height,
        mode: 'mobile',
        isDesktop: false,
        isMobile: true,
      };
    }
    
    const width = window.outerWidth || 0;
    const height = window.outerHeight || 0;
    const isDesktop = width > height;
    return {
      width,
      height,
      mode: isDesktop ? 'desktop' : 'mobile',
      isDesktop,
      isMobile: !isDesktop,
    };
  };

  const [state, setState] = useState(getSnapshot);

  useEffect(() => {
    const onResize = () => setState(getSnapshot());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return state;
}
